export default __webpack_public_path__ + "static/how-to-use-1f72eb7d5a8883eda26d55328f60dd14.mp4";